<template>
	<v-menu
		ref="menu"
		v-model="menu"
		:close-on-content-click="false"
		transition="scale-transition"
		offset-x
		style="z-index: 2002"
		:min-width="menuWidth"
		allow-overflow
		top
		left>
		<!-- ACTIVATOR -->
		<template #activator="{ on, attrs }">
			<v-text-field
				v-model="formattedDateTime"
				:label="label"
				readonly
				outlined
				dense
				hide-details
				v-bind="attrs"
				v-on="on"
				validate-on-blur
				:disabled="disabled"
				:error="!!errorMessage"
				:error-messages="errorMessage || ''" />
		</template>

		<v-card>
			<v-date-picker
				v-if="!showTimePicker"
				v-model="date"
				@input="onDateSelect"
				:min="minDate?.split(' ')[0]"
				scrollable
				hide-details
				:disabled="disabled" />
			<v-time-picker v-else v-model="time" format="24hr" @change="onTimeSelect" :disabled="disabled" />

			<v-card-actions>
				<v-spacer />
				<v-btn text color="primary" @click="menu = false">
					{{ $t('close') }}
				</v-btn>
				<v-btn v-if="date && time" text color="primary" @click="saveDateTime">
					{{ $t('ok') }}
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-menu>
</template>

<script>
export default {
	name: 'DateTimePicker',
	props: {
		value: {
			type: String,
			default: '',
		},
		label: {
			type: String,
			default () {
				return this.$t('selectDateTime');
			},
		},
		valid: {
			type: Boolean,
			default: false,
		},
		minDate: {
			type: String,
			default: '', // format 'YYYY-MM-DD'
		},
		errorMessage: {
			type: String,
			default: '', // format 'YYYY-MM-DD'
		},
		disabled: {
			type: Boolean,
			default: false, // format 'YYYY-MM-DD'
		},
	},
	data () {
		return {
			menu: false,
			date: null,
			time: null,
			menuWidth: 'auto', // default for date only
			showTimePicker: false,
		};
	},
	computed: {
		formattedDateTime () {
			if (!this.date || !this.time) return this.date || '';
			return `${this.date} ${this.time}`;
		},
	},
	watch: {
		value: {
			immediate: true,
			handler (val) {
				if (val) {
					const [date, time] = val.split(' ');
					this.date = date || null;
					this.time = time || null;
					this.updateMenuWidth();
				}
			},
		},
		date () {
			this.updateMenuWidth();
		},
		menu (val) {
			// Reset to date picker when menu opens
			if (val) {
				this.showTimePicker = false;
			}
		},
	},
	methods: {
		onDateSelect (value) {
			this.date = value;
			// Switch to time picker after date is selected
			this.showTimePicker = true;
		},
		onTimeSelect (value) {
			this.time = value;
		},
		saveDateTime () {
			this.menu = false;
			this.$emit('input', this.formattedDateTime);
		},
		updateMenuWidth () {
			this.$emit('update:valid', this.date !== null && this.time !== null); // <-- updates parent's bound prop
		},
	},
};
</script>
